module.exports = __webpack_public_path__ + "img/Insafety.aa1b6618.png";